<template>
    <v-container fluid>
        <Overlay />
        <v-row
            align="center"
            justify="center"
        >
            <v-col
                cols="12"
                md="11"
                class="d-flex flex-row justify-space-between align-center align-content-center"
            >
                <h1>Edit Field</h1>
                <v-spacer />
                <v-btn to="/field/create">
                    <v-icon
                        left
                        small
                    >
                        fas fa-plus-circle
                    </v-icon>
                    Add Field
                </v-btn>
            </v-col>
        </v-row>

        <v-row
            align="start"
            justify="center"
            class="d-flex flex-row justify-center"
        >
            <v-col
                cols="12"
                md="11"
                justify="center"
            >
                <FieldEditForm />
            </v-col>
        </v-row>

        <v-dialog
            v-model="deleteModal"
            width="500"
        >
            <v-card>
                <v-card-title>
                    <v-icon left>
                        fas fa-exclamation-triangle
                    </v-icon>Delete Field: {{ name }}
                </v-card-title>

                <v-card-text>
                    <p>You are about to remove this field. Deleting this field will also remove it's related structure and the submission fields from the user area. This cannot be undone. Any existing user data for this field will be orphaned.</p>
                    <p>Click "Delete Field" to proceed.</p>
                </v-card-text>

                <v-divider />

                <v-card-actions>
                    <v-spacer />
                    <v-btn
                        text
                        @click="toggleDeleteModal(false)"
                    >
                        Cancel
                    </v-btn>
                    <v-btn
                        color="primary"
                        @click="destroy()"
                    >
                        Delete Field
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import FieldEditForm from './FieldEditForm';
import Overlay from '../../../../components/Overlay';
import { mapActions, mapMutations, mapState } from 'vuex';

export default {
    components: { Overlay, FieldEditForm },

    computed: {
        ...mapState('fieldEditor', ['deleteModal', 'name'])
    },

    methods: {
        ...mapMutations({
            toggleDeleteModal: 'fieldEditor/toggleDeleteModal'
        }),

        ...mapActions({
            destroyData: 'fieldEditor/destroyData'
        }),

        destroy() {
            this.toggleDeleteModal(false);
            this.destroyData();
        }
    }
};
</script>
